var option_default = {
  "option": "_6jBc9",
  "user_choice": "MfVvx",
  "check": "Y-rA-",
  "image": "-YQG0",
  "input": "-G3js",
  "title": "O8Y4G",
  "centered": "Wrz0-",
  "with_result": "QXk57",
  "list": "NMvL7",
  "with_image": "_84t4m",
  "progress": "B-a2g",
  "progress_value": "L6JcB",
  "label": "cscnh",
  "cta": "xE0oZ",
  "adornment_icon": "HTenh",
  "remove": "_3rpZ0",
  "removeButton": "_5YwSq",
  "removeButtonIcon": "w5YuJ",
  "overlay": "_1-UHj",
  "shown": "YUmOd",
  "dark": "z-tyk",
  "spinner": "_6l406",
  "spin": "_6OokG"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
